import { render } from "./ResendEventEmailModal.vue?vue&type=template&id=73e6cb61&scoped=true"
import script from "./ResendEventEmailModal.vue?vue&type=script&lang=js"
export * from "./ResendEventEmailModal.vue?vue&type=script&lang=js"

import "./ResendEventEmailModal.vue?vue&type=style&index=0&id=73e6cb61&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73e6cb61"

export default script